import Company from '../images/home/category-company.jpg';
import Business from '../images/home/category-business.jpg';
import Society from '../images/home/category-society.jpg';
import People from '../images/home/category-people.jpg';

const data = [
  {
    title: 'COMPANY',
    items: [
      'company-category-01',
      'company-category-02',
      'company-category-03',
      'company-category-04',
      'company-category-05',
      'company-category-06',
    ],
    link: 'company',
    image: Company,
  },
  {
    title: 'BUSINESS',
    items: [
      'business-category-01',
      'business-category-02',
      'business-category-03',
      'business-category-04',
    ],
    link: 'business',
    image: Business,
  },
  {
    title: 'SOCIETY',
    items: [
      'society-category-01',
      'society-category-02',
      'society-category-03',
      'society-category-04',
    ],
    link: 'society',
    image: Society,
  },
  {
    title: 'PEOPLE',
    items: [
      'people-category-01',
      'people-category-02',
      'people-category-03',
      'people-category-04',
    ],
    link: 'people',
    image: People,
  },
];

export default data;
